// extracted by mini-css-extract-plugin
export default {"summaryText":"PrivacyTermModal_summaryText__2m1U3","detailText":"PrivacyTermModal_detailText__6tos3","emailLink":"PrivacyTermModal_emailLink__Fp6nV"};